import React from "react";
import PropTypes from "prop-types";
import store from "../../state/store";
import LoginModal from "../LoginModal";
import Events from "../../common/helpers/event-helpers/events";
import AddToast from "../../state/actions/AddToast";
import Modal from "../atoms/Modal";
import { DECLARE_OF_INTEREST_ERROR } from "./constants";
import isUserLoggedIn from "../../common/helpers/isUserLoggedIn";
import { httpRequest } from "../../services/http";
import { gray888 } from "../../common/helpers/colors";

class DeclareInterestForm extends React.Component {
  constructor() {
    super();
    this.componentName = "DeclareInterestForm";
    this.state = { data: { notes: "" }, modalOpen: false };
  }

  setObjectType(t) {
    this.setState({ objectType: t });
  }

  setSelectedGene(e) {
    this.setState({
      objectType: "gene_variants",
      selectedGene: e.target.value,
    });
  }

  saveClick = () => {
    // just log that form opened, no json_data
    const state = store.getState();
    const url = `${state.apiUrl}/declaration_of_interest/`;
    const data = {};
    data.query_id = state.variantResult.query_id;
    httpRequest.post(url, data);
  };

  toggleModal() {
    const { modalOpen } = this.state;
    const { genes } = this.props;
    const isModalOpen = !modalOpen;
    const storeState = store.getState();
    let selectedGene = null;
    if (Array.isArray(genes) && genes.length > 0) {
      [selectedGene] = genes;
    }
    const userEmail = storeState.userEmail || storeState.user?.email;
    const userName =
      storeState.userName ||
      `${storeState.user?.first_name} ${storeState.user?.last_name}`;
    const state = {
      loading: false,
      error: null,
      accept: false,
      object_type:
        storeState.queryType === "gene" ? "gene_variants" : "cur_variant",
      selectedGene,
      data: {
        title: storeState.userTitle,
        name: userName,
        organisation: storeState.userOrganisation,
        email: userEmail,
        notes: "",
      },
      modalOpen: isModalOpen,
    };
    this.setState(state);
    if (isModalOpen) this.saveClick();
  }

  toggleLoginModal() {
    const { showLoginModal } = this.state;
    this.setState({ showLoginModal: !showLoginModal });
  }

  saveEntry() {
    const { data, objectType, selectedGene } = this.state;
    const { variantId } = this.props;
    const state = store.getState();
    const url = `${state.apiUrl}/declaration_of_interest/`;
    const newState = { error: null, loading: true };
    this.setState(newState);
    const dataEntries = {};
    dataEntries.json_data = {
      name: data.name,
      email: data.email,
      notes: data.notes,
      organisation: data.organisation,
    };
    dataEntries.query_id = state.variantResult.query_id;

    if (objectType === "cur_variant") {
      dataEntries.variant_id = variantId;
    } else {
      dataEntries.gene = selectedGene;
    }
    httpRequest
      .post(url, dataEntries)
      .then((response) => {
        AddToast("Declaration of interest submitted!", "success");
        const { data: res } = response;
        if (res.variant_id) {
          store.dispatch({
            type: "CHANGE_VARIANT_ID",
            variant_id: res.variant_id,
          });
        }
        Events.dispatch("DECLARATION_MODIFIED");
        this.toggleModal();
      })
      .catch((error) => {
        console.error("Error submitting Declaration of interest:", error);
        this.setState({
          error: DECLARE_OF_INTEREST_ERROR,
        });
      });
  }

  valueChanged(field, e) {
    const newValue = e.target.value;
    const { data } = this.state;
    data[field] = newValue;
    this.setState({ data });
  }

  render() {
    const { text, genes, variantId } = this.props;
    const {
      accept,
      data,
      loading,
      error,
      modalOpen,
      showLoginModal,
      objectType,
    } = this.state;
    const clickEvent = isUserLoggedIn()
      ? () => this.toggleModal()
      : () => this.toggleLoginModal();

    const tmpl = (
      <div>
        <a onClick={clickEvent}>{text}</a>
      </div>
    );

    const controls = (
      <div
        style={{ borderTop: "1px solid #ddd" }}
        className="varsome-modal-controls varsome-clearfix tw-pt-4"
      >
        <button
          type="button"
          className="btn btn-danger varsome-left"
          onClick={() => this.toggleModal()}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success varsome-right"
          onClick={() => this.saveEntry()}
          disabled={
            !accept || data.notes.length < 70 || !data.name || !data.email
          }
        >
          Submit
          <i className="varsome-icons icon-chevron-right tw-ml-2 tw-text-xs" />
        </button>
      </div>
    );

    const modalForm = (
      <div className="col-12 col-xs-12">
        <form>
          <div className="row">
            <div className="col-md-6 col-12 col-xs-12 split-form-modal">
              <div>
                <label className="varsome-text-muted tw-text-xs" htmlFor="name">
                  {"NAME "}
                  {data.name ? (
                    <i className="fa fa-check tw-text-green-500" />
                  ) : (
                    <i
                      className="fa fa-times tw-text-red-500"
                      data-tooltip="Required"
                    />
                  )}
                </label>
                <br />
                <input
                  className="form-control"
                  type="text"
                  name="name"
                  required={true}
                  placeholder="Name..."
                  value={data.name}
                  onChange={(e) => this.valueChanged("name", e)}
                />
              </div>
              <div>
                <label
                  className="varsome-text-muted tw-text-xs"
                  htmlFor="email"
                >
                  {"EMAIL "}
                  {data.email ? (
                    <i className="fa fa-check tw-text-green-500" />
                  ) : (
                    <i
                      className="fa fa-times tw-text-red-500"
                      data-tooltip="Required"
                    />
                  )}
                </label>
                <br />
                <input
                  className="form-control"
                  type="text"
                  name="email"
                  required={true}
                  placeholder="Email..."
                  value={data.email}
                  onChange={(e) => this.valueChanged("email", e)}
                />
              </div>
              <div>
                <label
                  className="varsome-text-muted tw-text-xs"
                  htmlFor="organisation"
                >
                  ORGANIZATION
                </label>
                <br />
                <input
                  className="form-control"
                  type="text"
                  name="organisation"
                  placeholder="Organization..."
                  value={data.organisation}
                  onChange={(e) => this.valueChanged("organisation", e)}
                />
              </div>
              <div className="tw-mt-8">
                <label
                  className="tw-cursor-pointer"
                  htmlFor="accept"
                  onClick={() => {
                    this.setState({
                      accept: !accept,
                    });
                  }}
                >
                  <input
                    type="checkbox"
                    name="accept"
                    checked={accept}
                    onChange={(e) => {
                      this.setState({
                        accept: e.target.checked,
                      });
                    }}
                  />
                  &nbsp;&nbsp;I authorize VarSome to disclose the above
                  information to other users who accept to connect with me.
                </label>
              </div>
            </div>
            <div className="col-md-6 col-12 col-xs-12">
              <div>
                <label htmlFor="notes">
                  {`Describe why you want to connect with other users who have
                    queried or will query`}
                  {store.getState().queryType === "gene"
                    ? ` a variant of this gene. `
                    : ` this variant. `}
                  {`The description may include the project you are working on and/or how a patient or
                    researcher may benefit from sharing knowledge. This information will be visible to 
                    the other users who visit this variant or gene page, so use this space to convince them to connect with you.`}
                  <br />
                  Please do not include information that may identify you or any
                  other individual.
                  <div className="varsome-text-muted tw-mt-4 tw-text-xs">
                    YOUR MESSAGE
                  </div>
                </label>
                <textarea
                  name="notes"
                  className="form-control"
                  rows="6"
                  required={true}
                  value={data.notes}
                  onChange={(e) => this.valueChanged("notes", e)}
                />
                <small className="varsome-text-muted">
                  {"Minimum 70 characters. "}
                  {data.notes.length >= 70 ? (
                    <i className="fa fa-check tw-text-green-500" />
                  ) : (
                    <i
                      className="fa fa-times tw-text-red-500"
                      data-tooltip="Required"
                    />
                  )}
                </small>
              </div>
            </div>
          </div>
          <div className="row tw-mt-4" />
        </form>
      </div>
    );

    let selectedOptions;

    if (
      store.getState().queryType !== "gene" &&
      Array.isArray(genes) &&
      genes.length > 0
    ) {
      selectedOptions = (
        <div>
          <label className="varsome-text-muted tw-text-xs">
            Which variant do you want to declare your interest on?
          </label>
          {variantId && (
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="object_type"
                id="cur_variant"
                value="cur_variant"
                checked={objectType === "cur_variant"}
                onChange={() => this.setObjectType("cur_variant")}
              />
              <label className="form-check-label" htmlFor="cur_variant">
                &nbsp;The variant on this page
              </label>
            </div>
          )}
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="object_type"
              id="gene_variants"
              value="gene_variants"
              checked={objectType === "gene_variants"}
              onChange={() => this.setObjectType("gene_variants")}
            />
            <label className="form-check-label" htmlFor="gene_variants">
              &nbsp;All variants on gene&nbsp;&nbsp;
              <select
                name="selectedGene"
                id="selectedGene"
                onChange={(e) => this.setSelectedGene(e)}
              >
                {genes.map((g, i) => (
                  <option key={i} value={g}>
                    {g}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      );
    }

    const content = (
      <div className="tw-max-w-7xl tw-w-90screen">
        <div
          className="tw-overflow-auto tw-p-6"
          style={{ maxHeight: "calc(80vh - 100px)" }}
        >
          <h4>Connection request</h4>
          {!loading && (
            <div className="varsome-modal-content">
              <div className="row">
                <div className="col-12 col-xs-12">
                  <p className="tw-text-lg">
                    Important discoveries can be made if those who have come
                    across rare variants share the knowledge they have obtained.
                    These discoveries may lead to research findings and
                    significantly improved outcomes for patients.
                  </p>
                  <p className="tw-text-lg">
                    <i
                      style={{ color: "#70A7FFFF" }}
                      className="fa fa-info-circle"
                    />
                    {` Your message will be emailed to users who previously
                      viewed this page, and it will be displayed on`}
                    {store.getState().queryType === "gene"
                      ? ` all variants pages of the gene `
                      : ` the page (or all variants of the gene if you choose that option) `}
                    {`for future visitors to see. However, your
                      identity will only be shown to users who also consent
                      to exchange their details with yours. When another
                      user accepts your connection request, an email will be
                      sent to both, revealing each other's name and email
                      address.`}
                  </p>
                  {selectedOptions}
                  <hr />
                  {modalForm}
                </div>
              </div>
            </div>
          )}

          {loading && (
            <div>
              {!error && (
                <div
                  className="varsome-text-center tw-pt-20 tw-px-0 tw-pb-0 tw-text-2xl"
                  style={{
                    color: gray888,
                  }}
                >
                  Please wait...
                </div>
              )}
              {error && (
                <div className="varsome-request-error pubmed-form-error tw-text-center">
                  {error}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="tw-px-6 tw-pb-6">{!loading && controls}</div>
      </div>
    );

    const modal = (
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => this.toggleModal()}
        ContentRender={() => {
          return content;
        }}
      />
    );

    return (
      <span>
        {tmpl}
        {modal}
        <LoginModal
          showModal={showLoginModal}
          toggleModal={() => this.toggleLoginModal()}
        />
      </span>
    );
  }
}

DeclareInterestForm.propTypes = {
  variantId: PropTypes.string,
  text: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  genes: PropTypes.arrayOf(PropTypes.any),
};

DeclareInterestForm.defaultProps = {
  variantId: null,
  text: null,
  genes: null,
};

export default DeclareInterestForm;
